import { combineReducers } from 'redux';
import retrieve from './retrieve';

export default combineReducers({
  retrieve,
});
